import React from 'react'
import styled from 'styled-components'
import {
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Row,
  Col,
} from 'reactstrap'
import get from 'lodash/get'
import { statusColor } from '../helpers/color'
import { FONTS, COLORS } from '../../../constants'

export const Compensate = (props) => {
  const data = get(props, 'data', [])

  return (
    <Modal
      isOpen={ get(props, 'showDetail') }
      toggle={ get(props, 'handleDetail') }
    >
      <ModalHeader toggle={ get(props, 'handleDetail') }>
        <Header>
          Compensate Work Request
        </Header>
      </ModalHeader>
      <ModalBody style={ { overflowY: 'auto', height: '500px' } }>
        <LabelTextInfo>Project Name</LabelTextInfo>
        <Row>
          <ColDataInfo>
            <TextInfo>{ get(data[0], 'project', '-') }</TextInfo>
          </ColDataInfo>
        </Row>
        <LabelTextInfo>Approver</LabelTextInfo>
        <Row>
          <ColDataInfo>
            <TextInfo>{ get(data[0], 'approver', '-') }</TextInfo>
          </ColDataInfo>
        </Row>
        <LabelTextInfo>Compensate Work Date</LabelTextInfo>
        <Row>
          <ColDataInfo>
            <TextInfo>{ get(data[0], 'start_date', '') } - { get(data[0], 'end_date', '') }</TextInfo>
          </ColDataInfo>
        </Row>
        <LabelTextInfo>Compensate Time</LabelTextInfo>
        <Row>
          <ColDataInfo>
            <TextInfo>{ get(data[0], 'compensate_time', '-') }</TextInfo>
          </ColDataInfo>
        </Row>
        <LabelTextInfo>Total Compensate Work Day</LabelTextInfo>
        <Row>
          <ColDataInfo>
            <TextInfo>{ get(data[0], 'days') } days</TextInfo>
          </ColDataInfo>
        </Row>
        { get(data[0], 'status', '') !== '' &&
          <div>
            <LabelTextInfo>Status</LabelTextInfo>
            <Row>
              <ColDataInfo>
                <span style={ { color: statusColor(get(data[0], 'status', '')), fontWeight: 'bold' } }>
                  <TextInfo>{ get(data[0], 'status', '-') }</TextInfo>
                </span>
              </ColDataInfo>
            </Row>
          </div>
        }
        { get(data[0], 'remark_request_user', '') !== '' &&
          <div>
            <LabelTextInfo>Remarks</LabelTextInfo>
            <Row>
              <ColDataInfo>
                <TextInfo>{ get(data[0], 'remark_request_user', '-') }</TextInfo>
              </ColDataInfo>
            </Row>
          </div>
        }
        { get(data[0], 'remark_approver', '') !== '' &&
          <div>
            <LabelTextInfo>Approver Remarks</LabelTextInfo>
            <Row>
              <ColDataInfo>
                <TextInfo>{ get(data[0], 'remark_approver', '-') }</TextInfo>
              </ColDataInfo>
            </Row>
          </div>
        }
        { get(data[0], 'remark_cancel', '') !== '' &&
          <div>
            <LabelTextInfo>Cancel Remarks</LabelTextInfo>
            <Row>
              <ColDataInfo>
                <TextInfo>{ get(data[0], 'remark_cancel', '-') }</TextInfo>
              </ColDataInfo>
            </Row>
          </div>
        }
        { data.length > 1 &&
        <div>
          <DropdownItem divider />
          <LabelTextInfo>Project Name</LabelTextInfo>
          <Row>
            <ColDataInfo>
              <TextInfo>{ get(data[1], 'project', '-') }</TextInfo>
            </ColDataInfo>
          </Row>
          <LabelTextInfo>Approver</LabelTextInfo>
          <Row >
            <ColDataInfo>
              <TextInfo>{ get(data[1], 'approver', '-') }</TextInfo>
            </ColDataInfo>
          </Row>
          <LabelTextInfo>Compensate Work Date</LabelTextInfo>
          <Row >
            <ColDataInfo>
              <TextInfo>{ get(data[1], 'start_date', '') } - { get(data[1], 'end_date', '') }</TextInfo>
            </ColDataInfo>
          </Row>
          <LabelTextInfo>Working Time</LabelTextInfo>
          <Row >
            <ColDataInfo>
              <TextInfo>{ get(data[1], 'working_time', '-') }</TextInfo>
            </ColDataInfo>
          </Row>
          <LabelTextInfo>Total Compensate Work Day</LabelTextInfo>
          <Row>
            <ColDataInfo>
              <TextInfo>{ get(data[0], 'days') } days</TextInfo>
            </ColDataInfo>
          </Row>
          { get(data[1], 'status', '') !== '' &&
            <div>
              <LabelTextInfo>Status</LabelTextInfo>
              <Row>
                <ColDataInfo>
                  <span style={ { color: statusColor(get(data[1], 'status', '')), fontWeight: 'bold' } }>
                    <TextInfo>{ get(data[1], 'status', '-') }</TextInfo>
                  </span>
                </ColDataInfo>
              </Row>
            </div>
          }
          { get(data[1], 'remark_request_user', '') !== '' &&
            <div>
              <LabelTextInfo>Remarks</LabelTextInfo>
              <Row>
                <ColDataInfo>
                  <TextInfo>{ get(data[1], 'remark_request_user', '-') }</TextInfo>
                </ColDataInfo>
              </Row>
            </div>
          }
          { get(data[1], 'remark_approver', '') !== '' &&
            <div>
              <LabelTextInfo>Approver Remarks</LabelTextInfo>
              <Row>
                <ColDataInfo>
                  <TextInfo>{ get(data[1], 'remark_approver', '-') }</TextInfo>
                </ColDataInfo>
              </Row>
            </div>
          }
          { get(data[1], 'remark_cancel', '') !== '' &&
            <div>
              <LabelTextInfo>Cancel Remarks</LabelTextInfo>
              <Row>
                <ColDataInfo>
                  <TextInfo>{ get(data[1], 'remark_cancel', '-') }</TextInfo>
                </ColDataInfo>
              </Row>
            </div>
          }
        </div>
        }
      </ModalBody>
    </Modal>
  )
}

const LabelTextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-bottom: 0px;
`
const ColDataInfo = styled(Col)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const Header = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const TextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`



// WEBPACK FOOTER //
// ./src/components/my-leave/modal/compensate.js